const TAB_MODULE_MAP = {
  // Self-service groups. Each tab maps to the module its API already sits
  // behind, so a tenant that has not bought a module never sees the tab.
  growth: 'reports',
  'growth-learning': 'reports',
  'growth-skills': 'reports',
  'growth-okrs': 'reports',
  'growth-review': 'reports',
  workplace: 'employees',
  'workplace-announcements': 'employees',
  'workplace-directory': 'employees',
  'workplace-org-chart': 'employees',
  'workplace-kb': 'helpdesk',
  'workplace-referrals': 'onboarding',
  account: 'employees',
  'account-notifications': 'employees',
  'account-devices': 'employees',
  'account-tax-statement': 'finance',
  'account-loans': 'employees',
  dashboard: 'dashboard',
  'ai-command': 'dashboard',
  'ai-center': 'dashboard',
  'ai-center-attendance-insight': 'dashboard',
  'ai-center-hiring-forecast': 'dashboard',
  'ai-center-payroll-forecast': 'dashboard',
  'ai-center-team-performance': 'dashboard',
  'ai-center-settings': 'dashboard',
  employees: 'employees',
  onboarding: 'onboarding',
  'onboarding-employees': 'onboarding',
  'onboarding-documents': 'onboarding',
  'onboarding-checklists': 'onboarding',
  assets: 'assets',
  attendance: 'attendance',
  'rules-shifts': 'attendance',
  'rules-penalties': 'attendance',
  leaves: 'leave',
  'leave-my-history': 'leave',
  'leave-my-apply': 'leave',
  'leave-approvals-inbox': 'leave',
  'leave-requests': 'leave',
  'leave-holidays': 'leave',
  'leave-my-holidays': 'leave',
  'leave-policies': 'leave',
  'leave-regularization': 'leave',
  'leave-wfh': 'leave',
  'leave-outstation': 'leave',
  finance: 'finance',
  'finance-home': 'finance',
  'finance-my': 'finance',
  'finance-process': 'finance',
  'finance-payslips': 'finance',
  'finance-config': 'finance',
  'finance-structures': 'finance',
  'finance-tax-slabs': 'finance',
  'finance-reimbursements': 'finance',
  'esi-policy': 'esi',
  'esi-branches': 'esi',
  'esi-employees': 'esi',
  'esi-contributions': 'esi',
  'esi-challans': 'esi',
  benefits: 'benefits',
  'benefits-my': 'benefits',
  'benefits-plans': 'benefits',
  'benefits-enrollment': 'benefits',
  helpdesk: 'helpdesk',
  'engagement-rewards': 'gamification',
  'gamification-dashboard': 'gamification',
  'gamification-levels': 'gamification',
  'gamification-challenges': 'gamification',
  'gamification-competitions': 'gamification',
  'gamification-rewards': 'gamification',
  'gamification-rankings': 'gamification',
  'gamification-gift-vouchers': 'gamification',
  'gamification-achievements': 'gamification',
  'gamification-leaderboards': 'gamification',
  'gamification-campaigns': 'gamification',
  'gamification-settings': 'gamification',
  reports: 'reports',
  'report-employee': 'reports',
  'report-attendance': 'reports',
  'report-muster': 'reports',
  'report-leave': 'reports',
  'report-payroll': 'reports',
  'report-balance': 'reports',
  'report-statutory': 'reports',
  'report-performance': 'reports',
  'report-executive': 'executive_analytics',
  'pulse-surveys': 'pulse_surveys',
  fraud: 'fraud',
  geofence: 'geofence',
  master: 'master_data',
  'master-departments': 'master_data',
  'master-subdepartments': 'master_data',
  'master-designations': 'master_data',
  workspace: 'workspace_admin',
  // Roles & Access inside a workspace. Same module the backend maps
  // /api/access-control to for tenant callers, so the tab and the API agree.
  'access-control': 'workspace_admin',
  equity: 'equity',
  'my-equity': 'equity',
  integrations: 'integrations',
  'org-legal-entities': 'multi_entity',
  'org-business-units': 'multi_entity',
  'enterprise-sso': 'sso',
  // Education Suite — gated per module key; hidden until the tenant is licensed
  // (superadmin always sees it). The API is independently add-on-gated server-side.
  'edu-schools': 'edu_faculty',
  'edu-departments': 'edu_faculty',
  'edu-faculty': 'edu_faculty',
  'edu-calendar': 'edu_calendar',
  'edu-timetable': 'edu_timetable',
  'edu-courses': 'edu_timetable',
  'edu-rooms': 'edu_timetable',
  'edu-contracts': 'edu_contracts',
  'edu-accreditation': 'edu_accreditation',
  'edu-research': 'edu_research',
  'edu-grievance': 'edu_grievance',
  'edu-student-workers': 'edu_student_worker',
  'edu-adjunct': 'edu_adjunct',
  'edu-integrations': 'edu_integrations',
};

export const getModuleForTab = (tabId) => TAB_MODULE_MAP[tabId] || null;

export const hasModuleAccessForTab = (tabId, moduleAccess = [], isSuperadmin = false) => {
  if (isSuperadmin) return true;
  const moduleKey = getModuleForTab(tabId);
  if (!moduleKey) return true;
  return (moduleAccess || []).includes(moduleKey);
};

export const filterNavByModuleAccess = (schema = [], moduleAccess = [], isSuperadmin = false) => {
  if (isSuperadmin) return schema;
  return (schema || [])
    .map((item) => {
      if (Array.isArray(item.subItems) && item.subItems.length > 0) {
        const filteredSubItems = item.subItems.filter((sub) => hasModuleAccessForTab(sub.id, moduleAccess, isSuperadmin));
        // A group with nothing left in it is not a menu entry, it is a dead
        // arrow. This used to survive whenever the group's own id had no module
        // mapping — which is every group added by the nav regroup, so an
        // unlicensed tenant would have seen an empty "Education" to click on.
        if (filteredSubItems.length === 0) return null;
        return { ...item, subItems: filteredSubItems };
      }
      return hasModuleAccessForTab(item.id, moduleAccess, isSuperadmin) ? item : null;
    })
    .filter(Boolean);
};

/**
 * Per-role menu visibility, applied after the plan's module gate.
 *
 * `menuAccess` is null on every tenant that has never opened the Menus editor,
 * and that has to keep meaning "everything" — an empty array would blank the
 * sidebar for the entire product the day the column shipped.
 *
 * `menuDenied` always subtracts, whether or not there is an allow-list: it is a
 * per-user exception on top of the role, and a deny that only worked when the
 * role happened to carry a restriction would be a deny that mostly did nothing.
 *
 * Nothing here grants. The module gate has already run and the server refuses
 * whatever this wrongly shows.
 */
export const filterNavByMenuAccess = (schema = [], menuAccess = null, menuDenied = []) => {
  const denied = new Set(menuDenied || []);
  const allowed = Array.isArray(menuAccess) ? new Set(menuAccess) : null;
  if (!allowed && denied.size === 0) return schema;

  const visible = (id) => !denied.has(id) && (!allowed || allowed.has(id));

  return (schema || [])
    .map((item) => {
      if (Array.isArray(item.subItems) && item.subItems.length > 0) {
        const subItems = item.subItems.filter((sub) => visible(sub.id));
        // A group whose children are all hidden is an arrow to nowhere, exactly
        // as in filterNavByModuleAccess above.
        if (!subItems.length || denied.has(item.id)) return null;
        return { ...item, subItems };
      }
      return visible(item.id) ? item : null;
    })
    .filter(Boolean);
};
